class InstructorCourseController {} 
InstructorCourseController.$inject = [];
export default InstructorCourseController;